<template>
  <v-dialog :value="value" width="900px" @input="$emit('input', false)">
    <v-card>
      <v-card-title>
        <span class="section-title">Histórico de pontos</span>
        <v-spacer />
        <span class="link" @click="exportCSV">exportar .csv</span>
      </v-card-title>
      <v-card-text>
        <v-row class="py-0">
          <v-col class="py-1">
            <span class="card-title pl-0">{{ user.name }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1">
            <span class="card-title pl-0">{{ user.document_no | cpfCnpj }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-0">
            <v-tabs v-model="tab" grow>
              <v-tab> Processamento de pontos </v-tab>
              <v-tab> Logs de alteração </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <points-history-processed ref="tab-0" :user="user" />
              </v-tab-item>
              <v-tab-item>
                <points-history-update-log ref="tab-1" :user="user" />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: () => $emit('input', false),
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
    <loading-dialog-standalone :loading="exportingCsv" />
  </v-dialog>
</template>

<script>
export default {
  components: {
    PointsHistoryProcessed: () => import('@/modules/clientes/gerenciamento/views/components/PointsHistoryProcessed.vue'),
    PointsHistoryUpdateLog: () => import('@/modules/clientes/gerenciamento/views/components/PointsHistoryUpdateLog.vue'),
    LoadingDialogStandalone: () => import('@/components/LoadingDialogStandalone.vue'),
  },
  props: {
    value: Boolean,
    user: Object,
  },
  data: () => ({
    tab: 0,
    exportingCsv: false,
  }),
  methods: {
    async exportCSV() {
      this.exportingCsv = true
      try {
        await this.$refs[`tab-${this.tab}`].exportCSV()
      } catch (e) {
        console.log(e)
        this.$snackbar({ message: 'Falha ao exportar arquivo.' })
      }
      this.exportingCsv = false
    },
  },
}
</script>
